import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupportRequestRoutingModule } from './tickets.routing';
import { FileViewerComponent, TicketCreationConfirmationComponent, TicketFormComponent } from './form/ticket-form.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { TicketMessagerComponent } from './messages/ticket-messager.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@NgModule({
    declarations: [ TicketFormComponent, FileViewerComponent, TicketCreationConfirmationComponent, TicketMessagerComponent ],
    imports: [ CommonModule, SupportRequestRoutingModule, SharedModule ],
    exports: [ ],
    providers: [ {provide: MAT_DIALOG_DATA, useValue: null} ],
})
export class TicketModule {}